import { MODAL_TYPES } from '../consts';

export const isModalModifier = (modifier: string) => {
  return (
    modifier === MODAL_TYPES.CHEVY ||
    modifier === MODAL_TYPES.CHEVYPREMIUM ||
    modifier === MODAL_TYPES.CHEVYPREMIUM_CONTROL ||
    modifier === MODAL_TYPES.CHEVYPREMIUM_CONTROL1 ||
    modifier === MODAL_TYPES.CHEVYPREMIUM_PERSONAL ||
    modifier === MODAL_TYPES.UNIFIED_CHEVY_PREMIUM ||
    modifier === MODAL_TYPES.PASSWORDGEN ||
    modifier === MODAL_TYPES.BIZMAX
  );
};
